import { Bell, Contrast, Crop, FlipHorizontal2, Palette, Sparkles, Square, Sticker, Type, ZoomIn } from 'lucide-react';

/* One drawn icon per effect type, shared by every place an effect is offered
   (the inspector's add buttons, the Media tab menu, AI suggestions), so a
   suggestion looks exactly like the effect it opens. */
export const EFFECT_ICONS = {
    text: Type,
    box: Square,
    crop: Crop,
    zoom: ZoomIn,
    sticker: Sticker,
    overlay: Bell,
    fade: Contrast,
    flip: FlipHorizontal2,
    look: Palette,
};

export const SUGGEST_ICON = Sparkles;
